
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
import { paginationTotal } from '../../utils/pagination'
// ADD CATEGORY
export const categoryAdd = createAsyncThunk(
    'category/categoryAdd',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const formData = new FormData()
            formData.append('name', info.name)
            formData.append('image', info.image)
            formData.append('isDigital', info.isDigital.toString()) // ✅ Boolean → String
            formData.append('icon', info.icon || '')
            formData.append('nameAz', info.nameAz || '')
            formData.append('parentId', info.categoryType === 'sub' ? (info.parentId || '') : '')
            formData.append('status', info.status || 'active')
            formData.append('displayOrder', String(info.displayOrder || 0))
            // ✅ Phase 2 — physical selling category flags
            formData.append('productKind', info.productKind || 'digital')
            formData.append('requiresPhysicalPermission', (info.requiresPhysicalPermission ? true : false).toString())
            formData.append('isPhysicalOnly', (info.isPhysicalOnly ? true : false).toString())
            formData.append('physicalListingConfig', JSON.stringify(info.physicalListingConfig || {}))


    const { data } = await api.post(`/category-add`, formData, { withCredentials: true })           
    return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// GET CATEGORIES
export const get_category = createAsyncThunk(
    'category/get_category',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const params = new URLSearchParams({ page, searchValue: searchValue || '', parPage })
            const { data } = await axios.get(`${api_url}/api/category-get?${params.toString()}`, { withCredentials: true })
            
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// DELETE CATEGORY
export const categoryDelete = createAsyncThunk(
    'category/categoryDelete',
    async (categoryId, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };  
        try {
           const { data } = await api.delete(`/category-delete/${categoryId}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const categoryEdit = createAsyncThunk(
    'category/categoryEdit',
    async ({ categoryId, info }, { rejectWithValue, fulfillWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: { 'Authorization': `Bearer ${token}` }
        // };
        try {
            const formData = new FormData()
            formData.append('name', info.name)
            formData.append('isDigital', info.isDigital)
            formData.append('icon', info.icon)
            formData.append('nameAz', info.nameAz || '')
            formData.append('parentId', info.categoryType === 'sub' ? (info.parentId || '') : '')
            formData.append('status', info.status || 'active')
            formData.append('displayOrder', String(info.displayOrder || 0))
            // ✅ Phase 2 — physical selling category flags
            formData.append('productKind', info.productKind || 'digital')
            formData.append('requiresPhysicalPermission', (info.requiresPhysicalPermission ? true : false).toString())
            formData.append('isPhysicalOnly', (info.isPhysicalOnly ? true : false).toString())
            formData.append('physicalListingConfig', JSON.stringify(info.physicalListingConfig || {}))

            // Yalnız yeni şəkil yüklənirsə əlavə et
            if (info.image && typeof info.image !== 'string') {
                formData.append('image', info.image)
            }

            const { data } = await api.put(`/category-edit/${categoryId}`, formData, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const categoryReducer = createSlice({
    name: 'category',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        categorys: [],
        categoryHierarchy: [],
        parentCategories: [],
        totalCategory: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            // ADD
            .addCase(categoryAdd.pending, (state) => {
                state.loader = true
            })
            .addCase(categoryAdd.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload.error
            })
            .addCase(categoryAdd.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                state.categorys = [...state.categorys, payload.category]
            })
            // GET
            .addCase(get_category.fulfilled, (state, { payload }) => {
                state.totalCategory = paginationTotal(payload, 'totalCategory')
                state.categorys = payload.categorys || payload.data || []
                state.categoryHierarchy = payload.categoryHierarchy || []
                state.parentCategories = payload.parentCategories || []
            })
            // DELETE
            .addCase(categoryDelete.pending, (state) => {
                state.loader = true
            })
            .addCase(categoryDelete.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload.error
            })
            .addCase(categoryDelete.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
            .addCase(categoryEdit.pending, (state) => {
                state.loader = true
            })
            .addCase(categoryEdit.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload.error
            })
            .addCase(categoryEdit.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
            })
    }
})

export const { messageClear } = categoryReducer.actions
export default categoryReducer.reducer
